import * as actionConsts from './authenticationActions';
var update = require('react/lib/update');

export const initState = {
  user: {
    fullname: null,
    role: null,
    username: null,
    id: null
  },
  isWaiting: false
}


export default function user(state=initState, action) {
  switch (action.type) {
    case actionConsts.LOGIN_REQUEST:
      return update(state, {
        isWaiting: {
          $set: true
        }
      });
    case actionConsts.LOGIN_SUCCESS:
    case actionConsts.LOGIN_FAILURE:
      return update(state, {
        isWaiting: {
          $set: false
        }
      });
    case actionConsts.USER_AUTH_UPDATE:
      return update(state, {
        user: {
          $set: {
            fullname: action.authObject.fullname,
            role: action.authObject.role,
            username: action.username,
            id: action.username
          }
        }
      });
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/App/Login/authenticationReducer.js